import React from "react";
import PropTypes from "prop-types";

const Syncing = (props) => {
  const { color, width, height, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      {...other}
    >
      <g id="Rectangle_1110" opacity="0">
        <rect width="20" height="20" stroke="none" fill="none" />
      </g>
      <g id="Group_5257" transform="translate(-12.313 -4.5)">
        <path
          id="Path_8742"
          d="M53.945,64.56,50.905,60l-3.04,4.56h1.653a5.264,5.264,0,0,1-8.465,2.547l-1.265,1.9a7.556,7.556,0,0,0,12.1-4.446Z"
          transform="translate(-21.633 -48.94)"
          fill={color}
        />
        <path
          id="Path_8743"
          d="M38.667,50a7.6,7.6,0,0,0-7.447,6.08H29.167l3.04,4.56,3.04-4.56H33.593a5.264,5.264,0,0,1,8.465-2.547l1.265-1.9A7.524,7.524,0,0,0,38.667,50Z"
          transform="translate(-15.854 -43.5)"
          fill={color}
        />
      </g>
    </svg>
  );
};

Syncing.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Syncing.defaultProps = {
  color: "#000000",
  width: 20,
  height: 20,
};

export default Syncing;



// WEBPACK FOOTER //
// ./src/components/Icons/Syncing.jsx